import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IBookmarkLocumJobs } from '../../models/dashboard/jobs/getBookmarkedLocumJobs.model';

interface IBookmarkMapping {
  jobId: string;
  bookmarkId: string;
}

interface IBookmarkedLocumJobsState {
  page: number;
  perPage: number;
  totalPages: number;
  totalElements: number;
  numberOfElements: number;
  first: boolean;
  last: boolean;
  bookmarkJobData: IBookmarkLocumJobs[];
  bookmarkMapping: IBookmarkMapping[];
}

const initialState: IBookmarkedLocumJobsState = {
  page: 1,
  perPage: 10,
  totalPages: 0,
  totalElements: 0,
  numberOfElements: 0,
  first: false,
  last: false,
  bookmarkJobData: [],
  bookmarkMapping: [],
};

const bookmarkedLocumJobsSlice = createSlice({
  name: 'bookmarkedLocumJobs',
  initialState,
  reducers: {
    // This reducer takes in the complete response, updates the state,
    // and computes the mapping from jobId to bookmarkId.
    getBookmarkedLocumJobs(
      state,
      action: PayloadAction<IBookmarkedLocumJobsState>
    ) {
      // Merge the new response data into the state
      state.page = action.payload.page;
      state.perPage = action.payload.perPage;
      state.totalPages = action.payload.totalPages;
      state.totalElements = action.payload.totalElements;
      state.numberOfElements = action.payload.numberOfElements;
      state.first = action.payload.first;
      state.last = action.payload.last;
      state.bookmarkJobData = action.payload.bookmarkJobData;
      // Compute the mapping for quick lookup later on.
      state.bookmarkMapping = action.payload.bookmarkJobData.map(
        (bookmark) => ({
          jobId: bookmark.job.id,
          bookmarkId: bookmark.id,
        })
      );
    },
    // Alternatively, if the bookmarkJobData gets updated independently,
    // this action can be used to re-compute the mapping.
    setBookmarkMapping(state) {
      state.bookmarkMapping = state.bookmarkJobData.map((bookmark) => ({
        jobId: bookmark.job.id,
        bookmarkId: bookmark.id,
      }));
    },
    // New action to add a bookmark mapping entry on-the-fly.
    addBookmarkMapping(state, action: PayloadAction<IBookmarkMapping>) {
      state.bookmarkMapping.push(action.payload);
    },
    removeBookmarkMapping(state, action: PayloadAction<{ jobId: string }>) {
      state.bookmarkMapping = state.bookmarkMapping.filter(
        (mapping) => mapping.jobId !== action.payload.jobId
      );
    },
    // New action to remove the actual bookmark from the bookmarkJobData array.
    removeBookmarkJobData(state, action: PayloadAction<{ jobId: string }>) {
      state.bookmarkJobData = state.bookmarkJobData.filter(
        (bookmark) => bookmark.job.id !== action.payload.jobId
      );
    },
  },
});

export const bookmarkedLocumJobsActions = bookmarkedLocumJobsSlice.actions;
export default bookmarkedLocumJobsSlice.reducer;
